module.exports = __webpack_public_path__ + "static/media/snall.40952bc4.mp3";